import React from 'react'
import PropTypes from 'prop-types'
import { getBezierPath, EdgeLabelRenderer } from '@xyflow/react'

const EDGE_COLORS = {
  onComplete: '#66BB6A',
  onFail: '#EF5350',
  default: '#90A4AE'
}

function WorkflowEdge ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style = {},
  markerEnd
}) {
  const edgeType = data?.edgeType ?? 'default'
  const color = EDGE_COLORS[edgeType] ?? EDGE_COLORS.default

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  })

  return (
    <>
      <path
        id={id}
        className='react-flow__edge-path'
        d={edgePath}
        style={{
          ...style,
          stroke: color,
          strokeWidth: 2
        }}
        markerEnd={markerEnd}
      />
      {edgeType !== 'default' ? (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              fontSize: 10,
              fontWeight: 600,
              color,
              backgroundColor: '#FFFFFF',
              padding: '1px 6px',
              borderRadius: 4,
              border: `1px solid ${color}`,
              pointerEvents: 'none'
            }}
          >
            {edgeType === 'onFail' ? 'fail' : 'ok'}
          </div>
        </EdgeLabelRenderer>
      ) : null}
    </>
  )
}

WorkflowEdge.propTypes = {
  id: PropTypes.string,
  sourceX: PropTypes.number,
  sourceY: PropTypes.number,
  targetX: PropTypes.number,
  targetY: PropTypes.number,
  sourcePosition: PropTypes.string,
  targetPosition: PropTypes.string,
  data: PropTypes.shape({
    edgeType: PropTypes.string
  }),
  style: PropTypes.object,
  markerEnd: PropTypes.string
}

export default WorkflowEdge
